import React from 'react';
import { FileText, CheckCircle, XCircle, AlertTriangle } from 'lucide-react';
import './LegalPage.css';

export default function AGBPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>📜 Allgemeine Geschäftsbedingungen (AGB)</h1>
        <p className="legal-intro">
          Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die Nutzung der PedalScot-Plattform.
        </p>

        <section>
          <h2><FileText size={24} className="section-icon" /> 1. Geltungsbereich</h2>
          <p>
            Diese AGB gelten für alle Nutzer der PedalScot-Website und -App. Durch die Registrierung 
            oder Nutzung unserer Dienste erklären Sie sich mit diesen Bedingungen einverstanden.
          </p>
        </section>

        <section>
          <h2><CheckCircle size={24} className="section-icon" /> 2. Leistungen</h2>
          <p>PedalScot bietet folgende Leistungen an:</p>
          <ul>
            <li>Zugang zu einer Datenbank von Radrouten in Schottland</li>
            <li>Informationen über Points of Interest (POIs)</li>
            <li>Community-Features (Bewertungen, Feedback)</li>
            <li>Routenplanung und Navigation</li>
            <li>Premium-Features (gegen Gebühr)</li>
          </ul>
        </section>

        <section>
          <h2>3. Registrierung und Nutzerkonto</h2>
          <h3>3.1 Registrierung</h3>
          <p>
            Die Nutzung einiger Funktionen erfordert eine Registrierung. Sie verpflichten sich, 
            wahrheitsgemäße Angaben zu machen und diese aktuell zu halten.
          </p>
          
          <h3>3.2 Passwort und Sicherheit</h3>
          <p>
            Sie sind für die Geheimhaltung Ihres Passworts verantwortlich. Teilen Sie Ihre 
            Zugangsdaten niemandem mit.
          </p>

          <h3>3.3 Konto-Löschung</h3>
          <p>
            Sie können Ihr Konto jederzeit in den Profil-Einstellungen löschen. Wir löschen 
            dann alle personenbezogenen Daten gemäß unserer Datenschutzerklärung.
          </p>
        </section>

        <section>
          <h2>4. Nutzungsrechte und -pflichten</h2>
          
          <h3>4.1 Erlaubte Nutzung</h3>
          <p>Sie dürfen die Plattform für folgende Zwecke nutzen:</p>
          <ul>
            <li>Persönliche, nicht-kommerzielle Routenplanung</li>
            <li>Teilen von Erfahrungen und Bewertungen</li>
            <li>Teilnahme an der Community</li>
          </ul>

          <h3>4.2 Verbotene Nutzung</h3>
          <div className="info-box warning">
            <AlertTriangle size={20} />
            <div>
              <p><strong>Folgende Handlungen sind untersagt:</strong></p>
              <ul>
                <li>Verbreitung illegaler, beleidigender oder irreführender Inhalte</li>
                <li>Spam, Werbung ohne Genehmigung</li>
                <li>Hacking, Reverse Engineering, Scraping</li>
                <li>Weitergabe von Zugangsdaten</li>
                <li>Verletzung von Rechten Dritter</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h2>5. Inhalte und geistiges Eigentum</h2>
          
          <h3>5.1 Unsere Inhalte</h3>
          <p>
            Alle Inhalte auf PedalScot (Texte, Bilder, Grafiken, Code) sind urheberrechtlich 
            geschützt. Eine Nutzung außerhalb der Plattform ist nur mit schriftlicher Genehmigung erlaubt.
          </p>

          <h3>5.2 Nutzer-Inhalte</h3>
          <p>
            Sie behalten alle Rechte an Ihren hochgeladenen Inhalten (Routen, Bewertungen, Fotos). 
            Sie gewähren uns jedoch eine nicht-exklusive, weltweite Lizenz zur Nutzung dieser Inhalte 
            im Rahmen der Plattform.
          </p>
        </section>

        <section>
          <h2>6. Premium-Mitgliedschaft</h2>
          
          <h3>6.1 Leistungsumfang</h3>
          <p>Premium-Mitglieder erhalten zusätzliche Features:</p>
          <ul>
            <li>Unbegrenzter Zugriff auf alle Routen</li>
            <li>Routenerstellung und -speicherung</li>
            <li>Werbefreie Nutzung</li>
            <li>Erweiterte Karten-Features</li>
          </ul>

          <h3>6.2 Kündigung</h3>
          <p>
            Die Premium-Mitgliedschaft kann jederzeit gekündigt werden und läuft zum Ende der 
            Abrechnungsperiode aus.
          </p>
        </section>

        <section>
          <h2><XCircle size={24} className="section-icon" /> 7. Haftungsausschluss</h2>
          
          <h3>7.1 Routenangaben</h3>
          <div className="info-box warning">
            <AlertTriangle size={20} />
            <div>
              <p>
                <strong>Wichtiger Hinweis:</strong> Alle Routenangaben sind ohne Gewähr. 
                Wir übernehmen keine Haftung für:
              </p>
              <ul>
                <li>Richtigkeit von Distanz-, Höhen- oder Zeitangaben</li>
                <li>Aktualität von Straßen- und Wegverhältnissen</li>
                <li>Sicherheit der empfohlenen Routen</li>
                <li>Unfälle oder Schäden während der Tour</li>
              </ul>
            </div>
          </div>

          <h3>7.2 Externe Links</h3>
          <p>
            Wir übernehmen keine Verantwortung für Inhalte externer Websites, auf die wir verlinken.
          </p>

          <h3>7.3 Verfügbarkeit</h3>
          <p>
            Wir bemühen uns um eine hohe Verfügbarkeit, können jedoch keine 100%ige Uptime garantieren.
          </p>
        </section>

        <section>
          <h2>8. Änderungen der AGB</h2>
          <p>
            Wir behalten uns vor, diese AGB jederzeit anzupassen. Registrierte Nutzer werden per 
            E-Mail über wesentliche Änderungen informiert.
          </p>
        </section>

        <section>
          <h2>9. Streitbeilegung</h2>
          <p>
            <strong>Anwendbares Recht:</strong> [Wählen Sie: Deutsches Recht / Schweizer Recht / etc.]<br />
            <strong>Gerichtsstand:</strong> [Ihr Gerichtsstand]
          </p>
        </section>

        <section>
          <h2>10. Kontakt</h2>
          <p>
            Bei Fragen zu diesen AGB kontaktieren Sie uns unter:<br />
            E-Mail: <a href="mailto:info@pedalscot.com">info@pedalscot.com</a>
          </p>
        </section>

        <section className="legal-meta">
          <p>
            <strong>Zuletzt aktualisiert:</strong> Januar 2025<br />
            <strong>Version:</strong> 1.0
          </p>
        </section>
      </div>
    </div>
  );
}
